var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 700,
    viewBox: "0 0 700 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M610.49 499.036C581.888 548.398 539.703 588.249 489.1 614.023L512.823 661.768C573.183 631.238 623.499 583.778 657.362 524.906L610.49 498.941L610.49 499.036Z",
    fill: "#005BAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M503.447 666.427L479.629 618.587C440.791 636.657 397.554 646.739 351.925 646.739C338.437 646.739 325.141 645.788 312.132 643.981L304.096 696.671C319.784 698.764 335.663 700 351.925 700C406.068 700 457.436 688.016 503.447 666.427Z",
    fill: "#EE2E62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.748 556.292C85.7096 502.841 53.5685 430.083 53.5685 350.001C53.5685 186.414 187.49 53.261 352.021 53.261C385.788 53.261 418.599 59.0626 449.305 69.7148L467.672 19.6875C431.226 6.94295 392.198 9.0002e-07 352.021 1.37912e-06C157.931 3.69362e-06 0.000123943 157.025 0.000126244 350.001C0.000127375 444.824 38.1676 530.898 99.9627 593.955L137.748 556.292Z",
    fill: "#00A664"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M301.807 642.461C241.542 632.285 187.495 604.132 145.215 563.711L107.43 601.374C157.554 649.594 222.028 683.168 293.771 695.152L301.807 642.461Z",
    fill: "#F58220"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M459.158 73.4231C551.086 108.899 622.734 188.505 643.97 288.274C644.926 292.934 645.883 297.69 646.648 302.445C649.039 316.997 662.719 326.888 677.354 324.511C691.99 322.133 701.938 308.532 699.547 293.981C698.59 288.369 697.538 282.758 696.39 277.241C671.232 159.306 586.384 65.1486 477.525 23.4909L459.158 73.5182L459.158 73.4231Z",
    fill: "#ABB2B6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M646.749 396.602C641.488 430.081 630.678 461.466 615.564 489.904L662.437 515.774C680.516 482.01 693.334 444.727 699.648 404.877C702.039 390.325 691.995 376.724 677.359 374.442C662.724 372.159 649.045 382.051 646.749 396.602Z",
    fill: "#27BDBE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.518313d1f1c1fb3b22a9f5157a520b92.svg";
export { ForwardRef as ReactComponent };